<script>
import Layout from '@layouts/simple'

const REPORTS_LIST = [
  { id: 1, name: 'AvailabilityOfTransmittersInTheWorkshop' },
  { id: 2, name: 'PoorBattery' },
  { id: 3, name: 'ToppingUpOil' },
  { id: 4, name: 'ShipmentMistakes' },
  { id: 5, name: 'UnresponsiveTransmittersAndPlugs' },
  { id: 6, name: 'InvalidMeasurement' },
  { id: 7, name: 'MergedButNotInitializedPlugs' },
]

export default {
  name: 'Alerts',
  components: {
    Layout,
  },
  computed: {
    list() {
      return REPORTS_LIST
    },
  },
}
</script>

<template>
  <Layout>
    <v-container fluid>
      <v-list>
        <v-list-tile
          v-for="item in list"
          :key="item.id"
          :to="{ name: 'alerts-view', params: { name: item.name }}"
        >{{ $t(`reports__${item.name}`) }}</v-list-tile>
      </v-list>
    </v-container>
  </Layout>
</template>
